import LoaderCircleIcon from '@liquidweb-dev/undercurrent/icons/animated/LoaderCircle';
import BrickWallFireIcon from '@liquidweb-dev/undercurrent/icons/lucide/BrickWallFire';
import CameraIcon from '@liquidweb-dev/undercurrent/icons/lucide/Camera';
import ConstructionIcon from '@liquidweb-dev/undercurrent/icons/lucide/Construction';
import GlobeIcon from '@liquidweb-dev/undercurrent/icons/lucide/Globe';
import RefreshCcwIcon from '@liquidweb-dev/undercurrent/icons/lucide/RefreshCcw';
import ShredderIcon from '@liquidweb-dev/undercurrent/icons/lucide/Shredder';
import { FixedColorSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';

export interface NotificationIconProps extends FixedColorSvgProps {
	notification?: string;
}

const NotificationIcon = ({ notification, ...rest }: NotificationIconProps) => {
	switch (notification) {
		case 'Reimage':
			return <RefreshCcwIcon {...rest} />;
		case 'Create image of server':
			return <CameraIcon {...rest} />;
		case 'Create server':
			return <ConstructionIcon {...rest} />;
		case 'Add IPs':
			return <GlobeIcon {...rest} />;
		case 'Activate / deactivate firewall rules':
			return <BrickWallFireIcon {...rest} />;
		case 'Terminating':
			return <ShredderIcon {...rest} />;
		default:
			return <LoaderCircleIcon {...rest} />;
	}
};

export default NotificationIcon;
